import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SectionConfigModel } from '../../models/section-configuration.model';
import { atLeastOne } from '../../validators/at-least-one-validator.directive';

@Component({
    selector: 'section-general-configuration',
    templateUrl: 'section-general-configuration.component.html',
    styleUrls: ['section-general-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionGeneralConfigurationComponent implements OnInit {
  @Input() sectionConfig: SectionConfigModel;
  @Input() parentFormGroup: FormGroup;

  expanded: boolean = true;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  addControls(): void {
    this.parentFormGroup.addControl('id', new FormControl({ value: this.sectionConfig.id, disabled: true }));
    this.parentFormGroup.addControl('weight', this.fb.control(this.sectionConfig.weight));
    this.parentFormGroup.addControl('name', this.fb.control(this.sectionConfig.name));
    this.parentFormGroup.addControl('localizationPath', this.fb.control(this.sectionConfig.localizationPath));
    this.parentFormGroup.addControl('navigationKey', new FormControl({ value: this.sectionConfig.navigationKey, disabled: true }));
    this.parentFormGroup.addControl('versions', this.fb.control(this.sectionConfig.versions ?? []));
    this.parentFormGroup.addControl('cssClasses', this.fb.control(this.sectionConfig.cssClasses ?? ''));

    this.parentFormGroup.addValidators(atLeastOne(Validators.required, ['name', 'localizationPath']));
    this.parentFormGroup.updateValueAndValidity({ emitEvent: false });
  }
}
